"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdjustmentDataVerifier = void 0;
var _utils = require("@/utils/utils");
var _adjustmentDataCache = require("./adjustmentDataCache");
class AdjustmentDataVerifier {
  constructor({
    cache,
    snowflakeClient
  }) {
    this.cache = cache;
    this.snowflakeClient = snowflakeClient;
  }
  async verify(collection) {
    const out = new _adjustmentDataCache.AdjustmentDataCache();

    // Verify adjustment types
    out.adjustmentTypes = this.cache.adjustmentTypes.union(collection.adjustmentTypes);

    // Verify account IDs
    await this.verifyAccountIds(collection.accountIds, out);
    const accountIds = Array.from(out.accountIds);

    // Verify payment entity close balance statuses
    out.paymentEntityCloseBalanceStatuses = this.cache.paymentEntityCloseBalanceStatuses;

    // Get contract IDs
    const contractIds = this.getContractIds(accountIds, collection.accountContractIds);
    await Promise.all([this.verifyAccountContracts(accountIds, contractIds, out), this.verifyAccountPaymentEntityIds(accountIds, out), this.verifyAccountUpcs(accountIds, Array.from(collection.upcs), out), this.verifyStatementPeriods(Array.from(collection.years), out)]);
    return out;
  }
  getContractIds(accountIds, accountContractIds) {
    const contractIds = new Set();
    for (const accountId of accountIds) {
      for (const contractId of accountContractIds.get(accountId) ?? []) {
        contractIds.add(contractId);
      }
    }
    return Array.from(contractIds);
  }
  async verifyAccountIds(accountIds, out) {
    // Check cache
    const cache = this.cache;
    const filtered = [];
    for (const accountId of accountIds) {
      if (cache.accountIds.has(accountId)) {
        out.accountIds.add(accountId);
      } else {
        filtered.push(accountId);
      }
    }

    // Check DB
    const stream = await this.snowflakeClient.getAccountIdsByAccountIds(filtered);

    // Update cache & output
    for await (const {
      id
    } of stream) {
      cache.accountIds.add(id);
      out.accountIds.add(id);
    }
  }
  async verifyAccountContracts(accountIds, contractIds, out) {
    const stream = await this.snowflakeClient.getAccountContractsByAccountIdsAndContractIds(accountIds, contractIds);
    for await (const {
      accountId,
      contractId
    } of stream) {
      (0, _utils.setMapSet)(out.accountContractIds, accountId, contractId);
    }
  }
  async verifyAccountPaymentEntityIds(accountIds, out) {
    // Check cache
    const cache = this.cache;
    const filtered = [];
    for (const accountId of accountIds) {
      const paymentEntityId = cache.accountPaymentEntityIds.get(accountId);
      if (paymentEntityId == null) {
        filtered.push(accountId);
      } else {
        out.accountPaymentEntityIds.set(accountId, paymentEntityId);
      }
    }
    const stream = await this.snowflakeClient.getAccountPaymentEntityIdsByAccountIds(filtered);
    for await (const {
      accountId,
      paymentEntityId
    } of stream) {
      cache.accountPaymentEntityIds.set(accountId, paymentEntityId);
      out.accountPaymentEntityIds.set(accountId, paymentEntityId);
    }
  }
  async verifyStatementPeriods(years, out) {
    // Check cache
    const cache = this.cache;
    const filtered = [];
    for (const year of years) {
      const monthPeriods = cache.statementPeriods.get(year);
      if (monthPeriods == null) {
        filtered.push(year);
      } else {
        out.statementPeriods.set(year, new Map(monthPeriods));
      }
    }

    // Check DB
    const stream = await this.snowflakeClient.getStatementPeriodsByYears(filtered);

    // Update cache & output
    for await (const period of stream) {
      (0, _utils.doubleMapSet)(cache.statementPeriods, period.year, period.month, period);
      (0, _utils.doubleMapSet)(out.statementPeriods, period.year, period.month, period);
    }
  }
  async verifyAccountUpcs(accountIds, displayUpcs, out) {
    const stream = await this.snowflakeClient.getUpcsByUpcsAndVendorIds(accountIds, displayUpcs);
    for await (const {
      displayUpc,
      vendorId,
      upc
    } of stream) {
      (0, _utils.setMapSet)(out.accountUpcs, vendorId, "" + upc);
      (0, _utils.setMapSet)(out.accountUpcs, vendorId, displayUpc.replace(/^0+/, ""));
    }
  }
}
exports.AdjustmentDataVerifier = AdjustmentDataVerifier;